import React from 'react';
import ReactDOM from 'react-dom/client';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import {
  createBrowserRouter,
  redirect,
} from "react-router-dom";
import './styles/index.scss';
import { getEnvironment } from './lib/utils';
import Providers from './providers'
import { PlansV3 } from './components/Plans';
import Enterprise from './components/Enterprise/Enterprise';
import { OnlySignup } from './components/Signup';
import { Member } from './components/Member';
import { Login, Logout } from './components/Login';
import { EmailVerify } from './components/EmailVerify';
import { InviteAccept } from './components/InviteAccept';
import { PasswordRecovery } from './components/PasswordRecovery';
import { ManageSeats } from './components/ManageSeats';
import BundleCheckoutSuccessPoc from './components/Bundles/BundleCheckoutSuccessPoc';
import reportWebVitals from './reportWebVitals';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Account } from './components/Account';
import { MarketplaceSuccess } from './components/MarketplaceSuccess';
import {
  MarketplaceCartIntake,
  MarketplaceCartPage,
  MarketplaceRouteGate,
} from './components/MarketplaceCart';
import { injectAttributionSnippet } from './lib/attributionEmbedSnippet';
import { ensureMetaPixel } from './lib/metaPixel';
import { resolveMarketplaceCohort } from './lib/marketplaceExperiment';
import featureFlags from './lib/featureFlags';
import {
  attachCrateCartGlobalApi,
  getMarketplaceCartController,
  installCrateCartBootstrap,
} from './lib/marketplaceCart';

window.crateVersion = '1.22.0';
window.bugsnagKey = process.env.REACT_APP_BUGSNAG_KEY || '748fc8c8b0858554332f17e8bc3b27ba';
injectAttributionSnippet();
ensureMetaPixel();
resolveMarketplaceCohort();
if (featureFlags.marketplaceCart) {
  installCrateCartBootstrap(window);
  const marketplaceCartController = getMarketplaceCartController(window);
  attachCrateCartGlobalApi(marketplaceCartController, window);
  marketplaceCartController.markReady();
}

//window.testSearch = (a,b) => console.log(a,b);

const rootElement = document.getElementById("root");

if(!rootElement) {
  

  window.renderReactHeader = (domTarget) => {
    ReactDOM.createRoot(domTarget).render(
        <Providers>
          <Header external={true} />
        </Providers>
    );
  };

  window.renderReactFooter = (domTarget) => {
    ReactDOM.createRoot(domTarget).render(<Footer/>);
  };
  
} else {
  
  const routes = [
    {
      path: "/",
      element: <PlansV3 />,
    },
    {
      path: "/register",
      element: <PlansV3 />,
    },
    {
      path: "/upgrade",
      element: <PlansV3 upgrade={true} />,
    },
    {
      path: "/upgrade/:msg",
      element: <PlansV3 upgrade={true} />,
    },
    {
      path: "/register/free",
      element: <PlansV3 forceFree={true} />,
    },
    {
      path: "/register/:campaign",
      element: <PlansV3 />,
    },
    {
      path: "/signup/:planId/:provider",
      element: <OnlySignup />,
    },
    {
      path: "/bundles/success",
      // Backup (previous success page):
      // element: <BundleCheckoutResult />,
      element: <BundleCheckoutSuccessPoc />,
    },
    {
      path: "/bundles/success-poc",
      element: <BundleCheckoutSuccessPoc />,
    },
    {
      path: "/marketplace/success",
      element: <MarketplaceSuccess />,
    },
    {
      path: "/marketplace/cart",
      element: (
        <MarketplaceRouteGate>
          <MarketplaceCartPage />
        </MarketplaceRouteGate>
      ),
    },
    {
      path: "/marketplace/cart/intake",
      element: <MarketplaceCartIntake />,
    },
    {
      path: "/email-verified",
      element: <EmailVerify verify={true} />,
    },
    {
      path: "/teams/member/invite/:code",
      element: <InviteAccept />,
    },
    {
      path: "/member/email-verify",
      element: <EmailVerify />,
    },
    {
      path: "/member/success",
      element: <Member subscriptionSuccess={true} />,
    },
    {
      path: "/member",
      element: <Account />,
    },
    {
      path: "/account",
      element: <Account />,
    },
    {
      path: "/account/teams-seats",
      element: <Account />,
    },
    {
      path: "/account/licenses",
      element: <Account />,
    },
    {
      path: "/account/assets",
      element: <Account />,
    },
    {
      path: "/account/billing",
      element: <Account />,
    },
    {
      path: "/account/purchases",
      loader: ({ request }) => {
        const url = new URL(request.url);
        return redirect(`/account/billing${url.search}${url.hash}`);
      },
    },
    {
      path: "/account/seats/manage",
      element: <ManageSeats />,
    },
    {
      path: "/logout",
      element: <Logout />,
    },
    {
      path: "/login",
      element: <Login />,
    },/*
    {
      path: "/search",
      element: <>
        <Header/>
        <div style={{display: 'flex', flexDirection:'column', gap:'24px', alignItems: 'center', width:' 100%', height: '500px',justifyContent: 'center', color: '#FFF'}}>
          IM SEARCH
          <input type="text" placeholder="Search..." style={{width: '200px', height: '50px', fontSize: '20px', padding: '10px'}} onChange={e => { const u = new URL(window.location); u.searchParams.set('main_category', e.target.value); window.history.replaceState({}, '', u); }} />
        </div>
        
        </>,
    },*/
    {
      path: "/login/google/callback",
      element: <Login remoteCallback="google" />,
    },
    {
      path: "/login/facebook/callback",
      element: <Login remoteCallback="facebook" />,
    },
    {
      path: "/login/portal/callback",
      element: <Login remoteCallback="portal" />,
    },
    {
      path: "/login/email/callback",
      element: <Login remoteCallback="email" />,
    },
    {
      path: "/password-recovery",
      element: <PasswordRecovery />,
    },
    {
      path: "/reset-password",
      element: <PasswordRecovery />,
    },
    {
      path: "/teams",
      element: <Enterprise />,
    },
    {
      path: "/enterprise",
      element: <Enterprise />,
    }
  ];

  const router = createBrowserRouter(routes);
  

  let WrappedComponent = (
    //<React.StrictMode>
      <Providers router={router} />
    //</React.StrictMode>
  );

  const BUGSNAG_KEY = window.bugsnagKey;

  if (BUGSNAG_KEY) {
    Bugsnag.start({
      apiKey:  BUGSNAG_KEY,
      plugins: [new BugsnagPluginReact()],
      releaseStage: getEnvironment(),
      appVersion: window.crateVersion,
      endpoints: {
        notify: 'https://bs-notify.productioncrate.com',
        sessions: 'https://bs-sessions.productioncrate.com'
      }
    });

    const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
    WrappedComponent = (
      <ErrorBoundary>
        {WrappedComponent}
      </ErrorBoundary>
    );
  }

  ReactDOM.createRoot(rootElement).render(WrappedComponent);



  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();

}
